import React from 'react'
import styles from './Global.module.css'

function LoadMoreButton(props) {
  return (
    <div className={styles.loadmore}>
        <button className="btn btn-default h-btn">{props.text ? props.text : 'Load more Videos'}</button>
    </div>
  )
}

export default LoadMoreButton